import TablaServidor from '../../components/tabla/TablaServidor';
import { useTituloCabecera } from '../../context/tituloCabeceraContext';
import { COLUMNAS_RECIBOS, TABLA_RECIBOS } from '../../components/recibos/columnasRecibos';

// Filtros rápidos: los de siempre del listado (empresa, centro de estudio, tipo de cliente,
// forma de pago, estado y rango de vencimiento) más «Facturado».
const FILTROS_RECIBOS = [
  'empresaId',
  'centro',
  'tipo_cliente',
  'forma_de_pago',
  'estado',
  'facturado',
  'fecha_vto',
];

// Por defecto, vencimientos de los últimos 30 días (se recalcula cada día; el usuario puede cambiarlo).
const FILTROS_INICIALES = { fecha_vto: { rango: 'ultimos30' } };

const ListadoRecibos = () => {
  useTituloCabecera('Recibos', 'Gestiona y busca recibos del sistema');
  return (
    <TablaServidor
      tablaKey={TABLA_RECIBOS}
      columnas={COLUMNAS_RECIBOS}
      filtrosRapidos={FILTROS_RECIBOS}
      filtrosIniciales={FILTROS_INICIALES}
      ruta="listado-recibos"
      archivo="recibos"
      nombreEntidad="recibos"
      placeholder="Buscar por nº de recibo, cliente, concepto o referencia…"
      claveFila={(f) => `${f.empresaId}-${f.recibo}`}
      tituloTarjeta={(f) => `#${f.recibo} · ${f.nombre || ''}`.trim()}
    />
  );
};

export default ListadoRecibos;
